module.exports = __webpack_public_path__ + "img/1F617.ee4e7a69.svg";